import React from "react";
import styled from "styled-components";

const PaddedSection = styled.div`
    padding: 0px 32px 0px 32px;
`;

export default PaddedSection;